<template>
  <div class="app d-flex flex-column">
    <div class="body align-self-center d-flex flex-column justify-content-center align-items-center">
        <div class="logo-container">
          <div v-html="svg.logo" class="signin-logo mb-4"></div>
        </div>
        <b-card no-body class="p-4 mb-0 input-card d-flex flex-column align-items-stretch">
          <b-card-body>
            <!-- <div>
              <div class="language-select"><Language /></div>
              <h4>{{ $t('AUTH.USER_LOGIN') }}</h4>
              <p>{{ $t('AUTH.EMAIL') }}</p>
              <b-input-group class="mb-3">
                <div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-user"></i></span></div>
                <input  type="text"
                        class="form-control"
                        :class="{'is-invalid': $v.user.email.$error, 'is-valid': !$v.user.email.$invalid}"
                        :placeholder="$t('AUTH.EMAIL')"
                        v-model="user.email"
                        @blur="$v.user.email.$touch()">
                <b-form-invalid-feedback v-if="!$v.user.email.required">{{ $t('AUTH.EMPTY_EMAIL') }}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.user.email.email">{{ $t('AUTH.INVALID_EMAIL') }}</b-form-invalid-feedback>
              </b-input-group>
              <p>{{ $t('AUTH.PASSWORD') }}</p>
              <b-input-group class="mb-4">
                <div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-lock"></i></span></div>
                <input  type="password"
                        class="form-control"
                        :class="{'is-invalid': $v.user.password.$error, 'is-valid': !$v.user.password.$invalid}"
                        :placeholder="$t('AUTH.PASSWORD')"
                        v-model="user.password"
                        @blur="$v.user.password.$touch()">
                <b-form-invalid-feedback v-if="!$v.user.password.required">{{ $t('AUTH.EMPTY_PASSWORD') }}</b-form-invalid-feedback>
              </b-input-group>
              <b-row>
                <b-col cols="12" class="text-center">
                  <b-button variant="secondary" class="login-btn" :disabled="$v.$invalid" @click="loginSubmit">{{ $t('AUTH.LOGIN') }}</b-button>
                </b-col>
              </b-row>
              <b-row class="action-btn-container">
                <b-col cols="12" class="text-center">
                  <b-button variant="link" class="px-0 mt-2" @click="forgotPasswordClicked"><h5>{{ $t('AUTH.FORGOT_PASSWORD') }}</h5></b-button>
                </b-col>
              </b-row>
            </div> -->
          </b-card-body>
          <!-- <b-col cols="12" class="text-center mb-2 seperator">
            <h5>OR</h5>
          </b-col> -->
          <b-row align-v="center">
            <b-col  cols="12" class="text-center">
              <span class="ms-label">Login with</span>
              <b-img src="../../../static/img/microsoft.png" fluid alt="Fluid image" @click="loginRedirect"></b-img>
            </b-col>
          </b-row>
        </b-card>
      </div>
    <Footer />
  </div>
</template>


<script>
import { required, email } from 'vuelidate/lib/validators'
import router from '../../router'
import svg from '../../_svg.js'
import Footer from '../../components/Footer'
import Language from '../../components/Header/Language'
import MsalAuto from '../../services/msal-autologin'
export default {
  name: 'Login',
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      svg: svg,
      event: null
    }
  },
  components: {
    Footer,
    Language
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  mixins: [ MsalAuto ],
  methods: {
    loginSubmit: function () {
      const {redirect_to: redirectUrl} = this.$route.query
      const payload = {authData: this.user, redirectpath: redirectUrl}
      this.$store.dispatch('logIn', payload)
    },
    loginOnEnter: function (event) {
      if (event.keyCode === 13) {
        this.loginSubmit()
      }
    },
    forgotPasswordClicked: function () {
      router.push('/forgot_password')
    }
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  mounted () {
    window.addEventListener('keyup', this.loginOnEnter)
  },
  destroyed () {
    window.removeEventListener('keyup', this.loginOnEnter)
  }
}
</script>

<style scoped>
.app {
  color: #0e2547;
}

.body {
  flex: 1 0 auto;
}

.label {
  font-size: 0.8rem;
}

.card input::placeholder {
  font-size: 0.7rem;
}

.card input:focus {
  outline: none;
}

.logo-container img {
  display: block;
}

.input-card {
  min-width: 30vw;
}

.input-container {
  border: 1px solid #d1d4d7;
  border-radius: 2px;
}

.input-card h4 {
  text-align: center;
}


.login-btn {
  border-radius: 15px;
  padding: 0.375rem 5.5rem;
  font-size: 1rem;
}

.language-select {
  margin-left: 90%;
  margin-bottom: -10%;
}

li {
  list-style-type: none;
}

.ms-label {
  font-size: 1.1rem;
}

.seperator h5 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
}

.seperator h5::before,
.seperator h5::after {
  content: "";
  display: block;
  flex-grow: 1;
  height: 1px;
  background: #ccc;
}

.seperator h5 span {
  padding: 0 2em;
}

@media screen and (max-width: 1000px) {
  .input-card {
    min-width: 70vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue